import {DateTime} from "luxon";
import {IdeaTicketInterface} from "@api/models/interfaces/tickets/IdeaTicketInterface";
import {Ticket} from "./Ticket";

export class Idea extends Ticket implements IdeaTicketInterface {
    costs: string | null;
    solution: string | null;
    hasBigEffect: boolean | null;
    effectFormation: string | null;
    canBeReplicated: boolean | null;
    publishedAt: string | DateTime | null;
    committeeReviewedAt: string | DateTime | null;
    bigCommitteeReviewedAt: string | DateTime | null;
    implementedAt: string | DateTime | null;

    feedBackUserName: string | null;
    realEconomicEffect: string | null;
    plannedEconomicEffect: string | null;
    realCosts: string;
    plannedImplementationDate: string | DateTime | null;
    authorReward: string;
    implementatorReward: string;
}